import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=c23e3c42&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports